var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-main",
            "ok-only": "",
            "ok-title": "Add",
            centered: "",
            size: "lg",
            title: "Add Equipment",
            "hide-footer": true,
          },
        },
        [_c("AddEquipment", { on: { refresh: _vm.refreshData } })],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit",
            "ok-only": "",
            "ok-title": "Add",
            centered: "",
            size: "lg",
            title: "Edit Equipment",
            "hide-footer": true,
          },
        },
        [
          _c("EditEquipment", {
            attrs: { equipment: _vm.equipmentData },
            on: { refresh: _vm.refreshData },
          }),
        ],
        1
      ),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "d-flex flex-column d-md-none" },
          [
            _c(
              "b-button",
              {
                staticClass: "my-1 w-100",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " + _vm._s("Booked = ") + " " + _vm._s(this.booked) + " "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                staticClass: "my-1 w-100",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Available = ") +
                    " " +
                    _vm._s(this.available) +
                    " "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                staticClass: "my-1 w-100",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Maintenance = ") +
                    " " +
                    _vm._s(this.maintenance) +
                    " "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                staticClass: "my-1 w-100",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " + _vm._s("Broken = ") + " " + _vm._s(this.broken) + " "
                ),
              ]
            ),
            _c(
              "b-button",
              {
                staticClass: "my-1 w-100",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Not Available = ") +
                    " " +
                    _vm._s(this.notAvailable) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "d-none d-md-flex justify-content-start" },
          [
            _c(
              "b-button",
              {
                staticClass: "my-1",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " + _vm._s("Booked = ") + " " + _vm._s(this.booked) + " "
                ),
              ]
            ),
            _c("b-col", { staticClass: "my-1", attrs: { md: "1", sm: "8" } }),
            _c(
              "b-button",
              {
                staticClass: "my-1",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Available = ") +
                    " " +
                    _vm._s(this.available) +
                    " "
                ),
              ]
            ),
            _c("b-col", { staticClass: "my-1", attrs: { md: "1", sm: "8" } }),
            _c(
              "b-button",
              {
                staticClass: "my-1",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Maintenance = ") +
                    " " +
                    _vm._s(this.maintenance) +
                    " "
                ),
              ]
            ),
            _c("b-col", { staticClass: "my-1", attrs: { md: "1", sm: "8" } }),
            _c(
              "b-button",
              {
                staticClass: "my-1",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " + _vm._s("Broken = ") + " " + _vm._s(this.broken) + " "
                ),
              ]
            ),
            _c("b-col", { staticClass: "my-1", attrs: { md: "1", sm: "8" } }),
            _c(
              "b-button",
              {
                staticClass: "my-1",
                staticStyle: {
                  "background-color": "transparent !important",
                  color: "#93bb3d !important",
                  "font-weight": "bold !important",
                },
                attrs: { disabled: "", variant: "primary" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s("Not Available = ") +
                    " " +
                    _vm._s(this.notAvailable) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.modal-main",
                    modifiers: { "modal-main": true },
                  },
                ],
                attrs: { variant: "primary" },
              },
              [
                _c("feather-icon", {
                  staticClass: "mr-50",
                  attrs: { icon: "PlusIcon" },
                }),
                _vm._v(" Add Equipment "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "1" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredEquipmentList,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(assetCode)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Equipment Code")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Search Equipment Code",
                            size: "sm",
                          },
                          on: {
                            input: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.assetCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "assetCode", $$v)
                            },
                            expression: "filters.assetCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(name)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Name")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Search Name", size: "sm" },
                          on: {
                            input: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "name", $$v)
                            },
                            expression: "filters.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(purchaseDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Purchase Date")]),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                            size: "sm",
                          },
                          on: {
                            change: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.purchaseDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "purchaseDateRange", $$v)
                            },
                            expression: "filters.purchaseDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(lifeEndDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Life End Date")]),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                            size: "sm",
                          },
                          on: {
                            change: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.lifeEndDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "lifeEndDateRange", $$v)
                            },
                            expression: "filters.lifeEndDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(maintainanceDate)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Maintenance Date")]),
                        _c("DatePicker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            range: "",
                            format: "YYYY-MM-DD",
                            placeholder: "Select date range",
                            size: "sm",
                          },
                          on: {
                            change: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.maintenanceDateRange,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "maintenanceDateRange", $$v)
                            },
                            expression: "filters.maintenanceDateRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(location)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Location")]),
                        _c("b-form-input", {
                          attrs: { placeholder: "Search Location", size: "sm" },
                          on: {
                            input: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.location,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "location", $$v)
                            },
                            expression: "filters.location",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "head(status)",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Status")]),
                        _c("b-form-select", {
                          attrs: { options: _vm.statusOptions, size: "sm" },
                          on: {
                            change: function ($event) {
                              _vm.currentPage = 1
                            },
                          },
                          model: {
                            value: _vm.filters.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 1
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(" Booked "),
                        ])
                      : data.item.status === 2
                      ? _c("b-badge", { attrs: { variant: "primary" } }, [
                          _vm._v(" Available "),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v(" Maintenance "),
                        ])
                      : data.item.status === 4
                      ? _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v(" Broken "),
                        ])
                      : _c("b-badge", { attrs: { variant: "danger" } }, [
                          _vm._v(" Not Available "),
                        ]),
                  ]
                },
              },
              {
                key: "cell(purchaseDate)",
                fn: function (data) {
                  return [
                    !data.item.purchaseDate
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.purchaseDate)) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(maintainanceDate)",
                fn: function (data) {
                  return [
                    !data.item.maintainanceDate
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDate(data.item.maintainanceDate)
                              ) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(lifeEndDate)",
                fn: function (data) {
                  return [
                    !data.item.lifeEndDate
                      ? _c("span", [_vm._v(" - ")])
                      : _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(data.item.lifeEndDate)) +
                              " "
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-edit",
                                modifiers: { "modal-edit": true },
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.getEquipmentData(data.item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "Edit2Icon" },
                            }),
                            _c("span", [_vm._v("Edit")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeEquipment(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", [_vm._v("Delete")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("p", [_vm._v("Total Records: " + _vm._s(this.totalRecords))]),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }